import * as React from "react";
import swal from "sweetalert";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Chip from "@material-ui/core/Chip";
import CircularProgress from "@material-ui/core/CircularProgress";
import { _get } from "../../Api";

const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const fetchData = (callback) => {
  _get("/nova/permissions/role")
    .then((res) => {
      callback(res.data);
    })
    .catch((e) => {
      swal({
        title: "Oops!",
        text: "Something went wrong.",
        icon: "error",
      });
      console.log(e);
    });
};

export default function AddRole(props) {
  const [roles, setRoles] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const handleClick = (name) => {
    props.onCheck(name);
  };

  if (loading) {
    fetchData((data) => {
      // filter roles user already has
      let rolesToChooseFrom = data.filter((role) => {
        return !props.user.roles.some((userRole) => {
          return userRole.id === role.id;
        });
      });
      setRoles(rolesToChooseFrom);
      setLoading(false);
    });
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <List>
      {roles.map((role) => {
        return (
          <ListItem>
            <Chip onClick={() => handleClick(role)} clickable label={capitalize(role.name)} />
          </ListItem>
        );
      })}
    </List>
  );
}
